export const defaults = {
    FILTER_analyticsGroupFilterChecked: [],
    FILTER_analyticsProviderFilterChecked:[],
    FILTER_analyticsUsersFilterChecked: [],
    
    FILTER_bestsellingAuthorFilterChecked: [],
    FILTER_bestsellingBisacCodeFilterChecked: [],
    FILTER_bestsellingBisacFilterChecked: [],
    FILTER_bestsellingProductFilterChecked: [],
    FILTER_bestsellingProviderFilterChecked: [],
    
    FILTER_bookstoreCategoryFilterChecked: [],
    FILTER_bookstoreProductFilterChecked: [],
    FILTER_bookstoreProviderFilterChecked: [],
    FILTER_bookstoreStoreFilterChecked: [],
    FILTER_bookstoreUfFilterChecked: [],

    FILTER_consultingPublisherBisacFilterChecked: [],
    FILTER_consultingPublisherPeriodFilterChecked: [],
    FILTER_consultingPublisherProviderFilterChecked: [],
    
    FILTER_marketBookstoreStoreFilterChecked: [],

    FILTER_marketCategoryFilterChecked: [],
    FILTER_marketProviderFilterChecked: [],
    FILTER_marketStampFilterChecked: [],
    
    FILTER_publisherAuthorFilterChecked: [],
    FILTER_publisherBisacCodeFilterChecked: [],
    FILTER_publisherBisacFilterChecked: [],
    FILTER_publisherBookFilterChecked: [],
    FILTER_publisherBookstoreFilterChecked: [],
    FILTER_publisherEconomicGroupFilterChecked: [],
    FILTER_publisherPublisherFilterChecked: [],
    FILTER_publisherStampFilterChecked: [],
    FILTER_publisherUfFilterChecked: [],
    
    analyticsGroupFilterChecked: [],
    analyticsProviderFilterChecked: [],
    analyticsUsersFilterChecked: [],
    
    bestsellingAuthorFilterChecked: [],
    bestsellingBisacCodeFilterChecked: [],
    bestsellingBisacFilterChecked: [],
    bestsellingProductFilterChecked: [],
    bestsellingProviderFilterChecked: [],
    
    bookstoreCategoryFilterChecked: [],
    bookstoreProductFilterChecked: [],
    bookstoreProviderFilterChecked: [],
    bookstoreStoreFilterChecked: [],
    bookstoreUfFilterChecked: [],

    consultingPublisherBisacFilterChecked: [],
    consultingPublisherPeriodFilterChecked: [],
    consultingPublisherProviderFilterChecked: [],

    marketCategoryFilterChecked:[],
    marketProviderFilterChecked: [],
    marketStampFilterChecked: [],

    marketBookstoreStoreFilterChecked: [],

    publisherAuthorFilterChecked: [],
    publisherBisacCodeFilterChecked: [],
    publisherBisacFilterChecked: [],
    publisherBookFilterChecked: [],
    publisherBookstoreFilterChecked: [],
    publisherEconomicGroupFilterChecked: [],
    publisherPublisherFilterChecked: [],
    publisherStampFilterChecked: [],
    publisherUfFilterChecked: [],

};


// WEBPACK FOOTER //
// ./src/graphql/defaults.tsx